import type { CourseStatus } from '@openclassrooms/sdk-web';

import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { clientApi } from '../../configuration';

export type UserCourseParams = {
  userId: number;
  courseId: number;
  queryParams?: {
    status?: CourseStatus;
  };
};

const { useGet: useUserCourse } = getCRUDHooks({
  entityName: 'userCourse',
  get: ({ userId, courseId, queryParams = {} }: UserCourseParams) =>
    clientApi
      .getOCClient()
      .helpers.learningActivity.courses.getWithNextChapter(userId, courseId, queryParams),
});

export default useUserCourse;
